import {createSlice} from "@reduxjs/toolkit";
import {fetchReconciliationExcelFile} from "./reconcilation.action";

interface InitState {
    data:any,
    error:any,
    isLoading:boolean
}

const initialState: InitState = {
    data: null,
    error: null,
    isLoading:false

}
const reconciliationSlice = createSlice({
    name: 'reconciliation',
    reducers: {
        setClearExcel: (state) => {
            //debugger
            state.data = null
            state.error = null
        },
    },
    initialState,
    extraReducers: builder => {
        builder
            .addCase(fetchReconciliationExcelFile.pending, ((state) => {
                state.isLoading = true
            }))
            .addCase(fetchReconciliationExcelFile.fulfilled, ((state, {payload}) => {
                state.isLoading = false
                state.data = payload
            }))
            .addCase(fetchReconciliationExcelFile.rejected, ((state, {error}) => {
                state.isLoading = false
                state.error = error
            }))
    }
})

export const {setClearExcel} = reconciliationSlice.actions

export default reconciliationSlice.reducer
